import React from 'react';

const Confirmation = () => {
  return (
    <div class="card">
      <div>
        <i class="checkmark">✓</i>
      </div>
      <h1>Success</h1>
      <p>
        We received your purchase request;
        <br /> we'll be in touch shortly!
      </p>
    </div>
  );
};

export default Confirmation;
